module.exports = __webpack_public_path__ + "9ac7e2ff6b9792291e65269b982efa35.otf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/HelveticaNeue/HelveticaNeueLTStd-Bd.otf
// module id = 341
// module chunks = 0